// extracted by mini-css-extract-plugin
export default {"root":"action_a_root__Gq4GR","content":"action_a_content__KvJXP","title":"action_a_title__xVhkH","text":"action_a_text__IRi9F","action":"action_a_action__3kjbL"};